/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:55
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-01 13:43:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/tools/index.ts
 */
import { checkAdvancedPrice } from './advancedPrice';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import { EnumUnitStandard } from 'src/types/common/common';
import { UnitType } from '@/src/types/common/common';
import { validate } from './validation';
import { settleData } from './submitData';
import { convertDatafromServer } from './convertDataFromServer';
export { validate, checkAdvancedPrice, settleData, convertDatafromServer };
export const defaultData = {
  linkedSalesChannels: [],
  storeUuid: '1',
  uuid: null,
  status: EnumStatus.Draft,
  measurementUnits: [],
  brands: [],
  countries: [],
  priceTiers: [],
  currencies: [],
  productInfo: {
    sku: '',
    name: '',
    measurementUnit: {},
    remarks: '',
    codes: [],
    description: '',
    brand: {},
    barcode: '',
  },
  tags: {
    tags: [],
  },

  // stock: {
  //   quotaEnabled: false,
  //   inventoryQuota: null,
  //   stockQuantity: 0,
  //   stockAvailable: 0,
  // },
  priceSettings: {
    defaultSalePrice: 0,
    taxRule: null,
    cost: 0,
    defaultRrp: null,
    localPrices: {},
  },
  advancedPriceSettings: [],
  advancedPriceSettingsOpen: true,
  dimensions: {
    weight: null,
    weightUnit: UnitType.Kilogram,
    measurementUnit: UnitType.Metre,
    length: null,
    width: null,
    volume: null,
    height: null,
  },
  customsInformation: {},
  customsInformationItems: [],
  productStorage: {},

  productType: EnumProductType.Simple,
  thumbnailImage: null,
  // inventoryStock: null,
  defaultCurrency: null,
  fileList: [],
  inventoryUuid: null,
  dimensionUnits: [
    { group: EnumUnitStandard.Imperial, values: [] },
    { group: EnumUnitStandard.Metric, values: [] },
  ],
  wightUnits: [
    { group: EnumUnitStandard.Imperial, values: [] },
    { group: EnumUnitStandard.Metric, values: [] },
  ],
  subCollapseOpen: {
    // salesChannelAvailableQuantity: true,
    // salesChannelAvailablePresaleQuantity: true,
  },
  // salesChannelAvailableQuantity: [],
  // salesChannelAvailablePresaleQuantity: [],
};
